"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JVMAccount = void 0;
const utils_1 = require("../../utils");
const operation_1 = require("../operation");
const transaction_1 = require("../transaction");
const account_1 = require("./account");
class JVMAccount extends account_1.UtxoAccount {
    provider;
    constructor(provider, wallet) {
        super(provider.jvmChain, provider.jvmApi, wallet);
        this.provider = provider;
    }
    async estimate(operation) {
        const provider = await this.provider.getStaticProvider();
        if (operation.type === operation_1.NetworkOperationType.Send) {
            return await (0, transaction_1.estimateSendOperation)(provider, this.chain, this, operation);
        }
        else if (operation.type === operation_1.NetworkOperationType.SendUtxo) {
            return await (0, transaction_1.estimateSendUtxoOperation)(provider, this.chain, this, operation);
        }
        throw new utils_1.AccountError(`unsupported operation: ${operation.type} for the chain with id: ${this.chain.id}`);
    }
    async execute(summary) {
        super.spend(summary.spendings);
        const operation = summary.operation.type;
        if (operation === operation_1.NetworkOperationType.Send) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.Send);
        }
        else if (operation === operation_1.NetworkOperationType.SendUtxo) {
            await this.executeAndTrackTransaction(summary, transaction_1.TransactionType.Send);
        }
        // balances fetching is needed to get new utxos created from this operation
        await super.refreshBalances();
    }
    async executeAndTrackTransaction(summary, type) {
        const executable = summary.getExecutable();
        const signedTx = await summary.fee.transaction.signTransaction(this.signers);
        const transactionHash = (await executable.provider.jvmApi.issueTx(signedTx)).txID;
        await executable.trackJVMTransaction(transactionHash, type);
    }
}
exports.JVMAccount = JVMAccount;
